<template lang="html">
  <material-card
    id="rate-card"
    :title="title"
    :text="text"
    dark
    hover
    color="busie">
    <v-layout justify-left wrap>
      <v-flex xs12>
        <v-text-field
          class="name-input"
          v-if="!rate.name"
          label="Name"
          v-model="payload.name"/>
        <span v-else id="name">{{ payload.name }}</span>
      </v-flex>
      <v-flex xs12>
        <rule-section :rule="payload.rule" @save="updateRule"/>
      </v-flex>
      <v-flex xs12>
        <rate-section :rates="payload.rates" @save="updateRates" />
      </v-flex>
    </v-layout>
    <template #actions>
      <v-spacer></v-spacer>
      <cancel-btn @click="clearAndClose" />
      <save-btn @click="initSave"/>
    </template>
  </material-card>
</template>

<script>
import MaterialCard from '@/components/material/Card';
import DatePicker from './DatePicker';
import EditButton from './EditButton';
import DeleteButton from './DeleteButton';
import SaveButton from './SaveButton';
import CancelButton from './CancelButton';
import RateSection from './RateSection';
import RuleSection from './RuleSection';

export default {
  components: {
    'material-card': MaterialCard,
    'date-picker': DatePicker,
    'edit-btn': EditButton,
    'delete-btn': DeleteButton,
    'save-btn': SaveButton,
    'cancel-btn': CancelButton,
    'rule-section': RuleSection,
    'rate-section': RateSection
  },
  props: {
    rate: { type: Object, required: false },
    title: { type: String, required: true, default: 'Rate Recipe' },
    text: { type: String, required: true, default: 'This is a rate Recipe' }
  },
  data () {
    return {
      payload: {}
    }
  },
  mounted () {
    this.createFreshPayload()
  },
  methods: {
    createFreshPayload () {
      this.payload = {
        name: this.rate.name,
        rule: this.rate.rule,
        rates: this.rate.rates.map(r => ({ name: r.name, value: r.value, type: r.type })),
        busType: this.rate.busType
      }
      if (this.rate.id) {this.payload.id = this.rate.id}
    },
    initSave () {
      this.$emit('save', this.payload)
      this.$emit('closeDialog')
    },
    updateRule (rule) {
      this.payload.rule = rule
      // this.initSave()
    },
    updateRates (rates) {
      this.payload.rates = rates
      // this.initSave()
    },
    clearAndClose () {
      this.createFreshPayload()
      this.$emit('closeDialog')
    }
  }
}
</script>

<style lang="css" scoped>
</style>
